import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Flame, FileText, AlertTriangle, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-navy text-white pt-24 pb-32 px-6 relative overflow-hidden" data-id="element-121">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-122">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-red-600 blur-[120px]" data-id="element-123"></div>
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mb-6" data-id="element-125">
          <div className="bg-red-900/40 border border-red-500/50 text-red-400 px-4 py-1.5 rounded-full text-sm font-bold flex items-center gap-2" data-id="element-126">
            <Flame size={16} data-id="element-127" />
            <span data-id="element-128">Oferta por tiempo limitado</span>
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-offwhite" style={{
        fontFamily: 'Calibri, Carlito, sans-serif'
      }} data-id="element-129">
          Cada discusión con tu ex{' '}
          <span className="text-amber-400" data-id="element-130">no termina ahí…</span>{' '}
          <br className="hidden md:block" data-id="element-131" />
          también afecta a tus hijos.
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-slate-300 mb-6 leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-132">
          Aprendé cómo responder{' '}
          <strong className="text-white" data-id="element-133">sin empeorar la situación</strong>.{' '}
          <br data-id="element-134" />
          Para padres separados que están{' '}
          <em data-id="element-135">cansados de no saber qué decir</em> cada vez que llega un mensaje.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.22
      }} className="flex flex-col items-center gap-3 mb-8 text-left max-w-md mx-auto" data-id="element-136">
          <div className="flex items-start gap-3" data-id="element-137">
            <CheckCircle2 className="text-green-500 flex-shrink-0 mt-0.5" size={20} data-id="element-138" />
            <span className="text-slate-200" data-id="element-139">
              ✔ <strong data-id="element-140">Aprendé a responder</strong> sin escalar el conflicto
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-141">
            <CheckCircle2 className="text-green-500 flex-shrink-0 mt-0.5" size={20} data-id="element-142" />
            <span className="text-slate-200" data-id="element-143">
              ✔ <strong data-id="element-144">Protegé la estabilidad emocional</strong> de tus hijos
            </span>
          </div>
          <div className="flex items-start gap-3" data-id="element-145">
            <CheckCircle2 className="text-green-500 flex-shrink-0 mt-0.5" size={20} data-id="element-146" />
            <span className="text-slate-200" data-id="element-147">
              ✔ <strong data-id="element-148">Recuperá tu paz mental</strong> en solo 7 días
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.25
      }} className="flex justify-center mb-10" data-id="element-149">
          <img src="https://cdn.magicpatterns.com/uploads/uq51jQTNwmqsiwsar4pHSg/Imagen_principal.png" alt="Clave de Paz: Padres Separados - Manual en formato PDF" className="w-72 md:w-96 lg:w-[28rem] h-auto drop-shadow-2xl rounded-lg" data-id="element-150" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex justify-center mb-10" data-id="element-151">
          <div className="bg-slate-800 border border-slate-700 text-slate-300 px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2" data-id="element-152">
            <FileText size={16} className="text-amber-400" data-id="element-153" />
            <span data-id="element-154">Herramienta en formato PDF · Descarga inmediata</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col items-center" data-id="element-155">
          <a href="https://clavedepaz.com/cart/44115100106851:1" className="bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-lg shadow-orange-500/30 transition-all transform hover:scale-105 active:scale-95 w-full sm:w-auto text-center" data-id="element-156">
            👉 QUIERO SABER QUÉ DECIR
          </a>
          <p className="text-sm text-slate-400 mt-4 flex items-center gap-2 font-medium" data-id="element-157">
            <span data-id="element-158">
              Ebook digital (PDF). No es libro físico. Acceso inmediato tras el
              pago.
            </span>
          </p>
          <p className="text-xs text-slate-500 mt-3 flex items-center gap-2" data-id="element-159">            
            <span className="w-1 h-1 rounded-full bg-slate-600" data-id="element-160"></span>
            <span data-id="element-161">100% seguro</span>
          </p>
        </motion.div>
      </div>
    </section>;
}